import {injectable} from "inversify";
import {computed, observable} from "mobx";
import {UserDetailsFragment} from "../types.d";

@injectable()
export class WorkspaceStore {

    @observable user: UserDetailsFragment;
    @observable _courseId: number;

    @computed get courseId() {
        return this._courseId;
    }

    set courseId(value) {
        if (value) {
            localStorage.setItem("courseId", value.toString());
        } else {
            localStorage.removeItem("courseId");
        }

        this._courseId = value;
    }

    getParam(name: string) {
        //
    }

}
